import { render, staticRenderFns } from "./BankVerification.vue?vue&type=template&id=35d61e5e"
import script from "./BankVerification.vue?vue&type=script&lang=js"
export * from "./BankVerification.vue?vue&type=script&lang=js"
import style0 from "./BankVerification.vue?vue&type=style&index=0&id=35d61e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports